export const msalConfig = {
  auth: {
    clientId:
      process.env.NODE_ENV === 'production'
        ? globalThis.__env.REACT_APP_AAD_CLIENT_ID
        : process.env.REACT_APP_AAD_CLIENT_ID,
    authority:
      process.env.NODE_ENV === 'production'
        ? globalThis.__env.REACT_APP_AAD_AUTHORITY
        : process.env.REACT_APP_AAD_AUTHORITY,
    postLogoutRedirectUri: '/'
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
}

export const loginRequest = {
  scopes: [process.env.NODE_ENV === 'production' ? globalThis.__env.REACT_APP_SCOPES : process.env.REACT_APP_SCOPES]
}
